import { useStore } from 'effector-react'
import { $confettiConfig, $isConfettiShown } from 'model/ui'
import Confetti from 'react-confetti'

export const ConfettiAnimation = () => {
  const isConfettiShown = useStore($isConfettiShown)
  const confettiConfig = useStore($confettiConfig)
  return isConfettiShown ? <Confetti {...confettiConfig} /> : null
}
